import React, { useEffect, useState } from "react";
// components
import Filtros from "./Filtros";
// utils
import XGridDemo from "../../components/utils/grid/Xgrid";
import CircularIndeterminate from "../../components/utils/spinner/Spinner";
// consts
import { cobrosTransferencias as titles } from "../../consts/titulos-de-tablas";
// services
import { SOCobrosTransferenciasGet } from "../../services/hooli-services/CobrosTransferencias/SOCobrosTransferenciasGet";
// recoil
import { useRecoilValue, useSetRecoilState } from "recoil";
import { userCredentials, rowSelected } from "../../recoilState/GlobalState";

export default function CobrosTransferencias() {
    const hoy = new Date().toISOString().slice(0, 10);

    const [filtros, setFiltros] = useState({
        cobroTransferenciaFecha: hoy,
        cobroTransferenciaMonto: "1000",
        cobroTransferenciaCUITOrigen: "",
        cobroTransferenciaReferencia: ""
    });
    const [cobros, setCobros] = useState([]);
    const [rows, setRows] = useState([]);
    const [cargando, setCargando] = useState(false);

    const credentials = useRecoilValue(userCredentials);
    const setRow = useSetRecoilState(rowSelected);

    const buildParams = () => {
        const params = {  };

        if (filtros.cobroTransferenciaFecha) params.cobroTransferenciaFecha = filtros.cobroTransferenciaFecha;
        if (filtros.cobroTransferenciaMonto) params.cobroTransferenciaMonto = Number(filtros.cobroTransferenciaMonto);
        if (filtros.cobroTransferenciaCUITOrigen) params.cobroTransferenciaCUITOrigen = filtros.cobroTransferenciaCUITOrigen;
        if (filtros.cobroTransferenciaReferencia) params.cobroTransferenciaReferencia = filtros.cobroTransferenciaReferencia;

        return params;
    };

    const retrieveCobros = async () => {
        if (!Object.keys(credentials).length) return;

        setCargando(true);
        setRows([]);
        setRow({ status: false });

        const payload = {
            ...credentials,
            params: buildParams()
        };

        const data = await SOCobrosTransferenciasGet(payload);
        setCobros(data || []);
        setCargando(false);
    };

    useEffect(() => {
        if (Object.keys(credentials).length > 0) retrieveCobros();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [credentials]);

    useEffect(() => {
        setRows([]);

        if (!cobros || !Array.isArray(cobros)) return;

        cobros.forEach((item, index) => {
            const {
                merchantNombre,
                cobroTransferenciaCUITOrigen,
                cobroTransferenciaMonto,
                cobroTransferenciaMontoCorregido,
                cobroTransferenciaReferencia,
                cobroTransferenciaRecibidoFH,
                cobroTransferenciaFinalizadaFH
            } = item;

            const row = {
                id: index + 1,
                [titles[0]]: merchantNombre,
                [titles[1]]: cobroTransferenciaCUITOrigen,
                [titles[2]]: cobroTransferenciaMonto,
                [titles[3]]: cobroTransferenciaMontoCorregido,
                [titles[4]]: cobroTransferenciaReferencia,
                [titles[5]]: cobroTransferenciaRecibidoFH,
                [titles[6]]: cobroTransferenciaFinalizadaFH
            };

            setRows(prev => [...prev, row]);
        });
    }, [cobros]);

    return (
        <main className="container">
            <Filtros
                filtros={filtros}
                setFiltros={setFiltros}
                cargando={cargando}
                onSearch={retrieveCobros}
            />
            <div className="row-grid">
                {cargando ? (
                    <CircularIndeterminate />
                ) : (
                    <XGridDemo rows={rows} titles={titles} />
                )}
            </div>
        </main>
    );
}
